
import '../style/Gallery.css'; // CSS dosyasını ekle
import React, { useState } from 'react';




const images = [

  {
    id: 1, src: require('../assets/erasmusHaber3.jpeg'), alt: 'Okulumuz Erasmus+ Bilgilendirme Toplantısı Yapıldı',
    legend: '2024 Teklif Çağrısı döneminde hibe almaya hak kazanan “Dünyamızın Kaderi Ellerimizde” başlıklı projemizin yürütülmesi hakkında bilgilendirme ve hareketliliklere katılacak öğretmenlerin seçimi ile ilgili kriterler ve puanlama sisteminin anlatıldığı Erasmus+ Projemizin 2. bilgilendirme toplantısı 06/09/2024 tarihinde tüm öğretmenlerimizin katılımı ile Zekai Gümüşdiş Ortaokulu konferans salonunda gerçekleştirildi. Öğretmenlerimiz seçim kriterleri ve yürütme ile ilgili ayrıntılı bilgiye sahip oldular.Başvuru ve değerlendirme sürecinin işleyişi konusunda tüm öğretmenlerimizin bilgilendirilmesi gerçekleştirildi.Şimdiden projemize aktif olarak katılacak tüm öğretmenlerimizi tebrik eder başarılar dileriz',
  },
  {
    id: 2, src: require('../assets/toplanti.jpeg'), alt: 'Okulumuz Erasmus+ Bilgilendirme Toplantısı Yapıldı',
    legend: 'Avrupa Komisyonu tarafından sağlanan fon ile ülkemizde Dışişleri Bakanlığı’na bağlı Türk Ulusal Ajansı tarafından koordine edilen Avrupa Birliği Başkanlığımızca yürütülmekte olan Erasmus+ Programı Okul Eğitimi Kısa Dönemli Öğrenci ve Personel Hareketliliği kapsamında 2024 yılı teklif çağrısı döneminde kabul listesinde yer alan 2024-1-TR01-KA122-SCH-000217833 proje nolu“Dünyamızın Kaderi Ellerimizde”başlıklı projemizin ilk bilgilendirme toplantısı,  02.09.2024 tarihinde Zekai Gümüşdiş Ortaokulu Konferans salonunda tüm öğretmenlerin katılımı ile gerçekleştirilmiştir',
  },
  {
    id: 3, src: require('../assets/erasmusHaber5.jpeg'), alt: 'Zekai Gümüşdiş Ortaokulu Erasmus+  KA 122 Sch Dünyamızın Kaderi Ellerimizde Projesi Yönetim Kurulu Toplantısı',
    legend: 'Zekai Gümüşdiş Ortaokulu Erasmus+  KA 122 Sch Dünyamızın Kaderi Ellerimizde Projesi yönetim kurulu, ilk toplantısını 05/09/2024 tarihinde Zekai Gümüşdiş Ortaokulunda gerçekleştirdi.Okul müdürü Muharrem Keskin, okul müdür yardımcısı Mustafa Sorkun, anasınıfı öğretmeni Gülşah Atalay ve matematik öğretmeni Aziz Turhan’ın hazır bulunduğu toplantıda , projenin yürütülmesi için gerekli iş ve işlemler hakkında görüşmelerde bulunuldu',
  },
  {
    id: 4, src: require('../assets/erasmuslogo.jpeg'), alt: 'Zekai Gümüşdiş Ortaokulu Erasmus+  Projesi Logoso',
    legend: 'Zekai Gümüşdiş Ortaokulu Erasmus+  KA 122 Sch Dünyamızın Kaderi Ellerimizde Projesi yönetim kurulu, ilk toplantısını 05/09/2024 tarihinde Zekai Gümüşdiş Ortaokulunda gerçekleştirdi.Okul müdürü Muharrem Keskin, okul müdür yardımcısı Mustafa Sorkun, anasınıfı öğretmeni Gülşah Atalay ve matematik öğretmeni Aziz Turhan’ın hazır bulunduğu toplantıda , projenin yürütülmesi için gerekli iş ve işlemler hakkında görüşmelerde bulunuldu',
  },
  {
    id: 5, src: require('../assets/logoanket.jpeg'), alt: 'Zekai Gümüşdiş Ortaokulu Erasmus+  Projesi Anket Sonuçları',
    legend: '',
  },
  {
    id: 6, src: require('../assets/toplanti1.jpeg'), alt: 'Erasmus+  Projesi Hareketlilik Öncesi Bilgilendirme Toplantısı',
    legend: 'Dünyamızın Kaderi Ellerimizde başlıklı Erasmus+KA 122 SCH projemiz kapsamında İspanya da gerçekleştireceğimiz Kurs ve İşbaşı Eğitim faaliyetine katılacak olan öğretmenlerimize hareketlilik öncesi bir bilgilendirme toplantısı  düzenledik.Katılımcı öğretmenlerimize başarılar diliyoruz.'
  },
  {
    id: 7, src: require('../assets/tolanti2.jpeg'), alt: 'Erasmus+  Projesi Hareketlilik Öncesi Bilgilendirme Toplantısı',
    legend: 'Dünyamızın Kaderi Ellerimizde başlıklı Erasmus+KA 122 SCH projemiz kapsamında İspanya da gerçekleştireceğimiz Kurs ve İşbaşı Eğitim faaliyetine katılacak olan öğretmenlerimize hareketlilik öncesi bir bilgilendirme toplantısı  düzenledik.Katılımcı öğretmenlerimize başarılar diliyoruz.'
  },
  {
    id: 8, src: require('../assets/toplanti3.jpeg'), alt: 'Erasmus+  Projesi Hareketlilik Öncesi Bilgilendirme Toplantısı',
    legend: 'Dünyamızın Kaderi Ellerimizde başlıklı Erasmus+KA 122 SCH projemiz kapsamında İspanya da gerçekleştireceğimiz Kurs ve İşbaşı Eğitim faaliyetine katılacak olan öğretmenlerimize hareketlilik öncesi bir bilgilendirme toplantısı  düzenledik.Katılımcı öğretmenlerimize başarılar diliyoruz.'
  },
];


const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image); // Tıklanan resmi state'e atıyoruz
  };

  const handleCloseModal = () => {
    setSelectedImage(null); // Modalı kapatmak için state'i sıfırla
  };

  return (
    <div className="gallery-container">
      {images.map((image) => (
        <div key={image.id} className="gallery-item">
          <img
            src={image.src}
            alt={image.alt}
            className="gallery-img"
            onClick={() => handleImageClick(image)} // Resme tıklandığında modalı aç
          />
        </div>
      ))}

      {selectedImage && (
        <div className="modal" onClick={handleCloseModal}>
          <span className="close">&times;</span>
          <img className="modal-content" src={selectedImage.src} alt={selectedImage.alt} />
          <div className="caption">{selectedImage.alt}</div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
